import React from "react";
import PropTypes from "prop-types";

const BusStopResult = ({ RouteNo, RouteName, DestinationName, Due }) => (
  <div className="table__row" title={`Due in ${Due} mins`}>
    <span className="table__item table__item--route">{RouteNo}</span>
    <span className="table__item table__item--destination">
      {DestinationName} ({RouteName})
    </span>
    <span className="table__item table__item--due">{Due} mins</span>
  </div>
);

BusStopResult.defaultProps = {
  RouteNo: "",
  RouteName: "",
  DestinationName: "",
  Due: ""
};

BusStopResult.propTypes = {
  RouteNo: PropTypes.string,
  RouteName: PropTypes.string,
  DestinationName: PropTypes.string,
  Due: PropTypes.string
};

export default BusStopResult;
